import React from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Container } from "react-grid-system";
import { useParams, useHistory } from "react-router-dom"
// Components
import GoBack from "../../components/common/GoBack";
import RedirectAs404 from "../../components/common/RedirectAs404";

const projects = [
    {
        key: "suite-xs-ntt",
        title: "Suite XS (NTT)",
        desc: "Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blanditvel, luctus pulvinar, hendrerit id, lorem.",
        image: "6-1.jpg",
        author: "Razul Mondal",
        client: "NTT",
        date: "May 15th, 2019",
        icon: "ti-light-bulb",
        features: [
            {name: "Full architecture design of the application and its micro services.", done: true},
            {name: "Designed and developed application components in an Agile environment.", done: true},
            {name: "Involved in daily scrum implemented meetings and bi-weekly sprint planning’s.", done: true},
            {name: "Developed several REST web services and used JSON as a data exchange format.", done: true},
            {name: "Developed server-side business logic modules.", done: true},
            {name: "Actively participated in weekly code reviews.", done: true},
            {name: "Use VS Code as IDE tool to develop the application", done: true},
            {name: "Created technical documents based on epics as we complete the stories", done: true},
            {name: "Worked closely with project managers and other team members to form a team effort in development when have dependencies.", done: true},
            {name: "Closely worked with the QA team for testing and resolve bugs in the application.", done: true},
            {name: "Knowledge Transfer: Gave presentations to the other teams about the work we have done and explained various features we developed on the ongoing project.", done: true}
        ],
        tags: "Laravel, VueJs, MySQL, Lumen, REST API, AJAX"
    },
    {
        key: "compas-ntt",
        title: "COMPAS (NTT)",
        desc: "Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blanditvel, luctus pulvinar, hendrerit id, lorem.",
        image: "6-2.jpg",
        author: "Razul Mondal",
        client: "NTT",
        date: "May 15th, 2019",
        icon: "ti-light-bulb",
        features: [
            {name: "Designed and developed application components in an Agile environment.", done: true},
            {name: "Involved in daily scrum implemented meetings and bi-weekly sprint planning’s.", done: true},
            {name: "Developed several REST web services and used JSON as a data exchange format.", done: true},
            {name: "Developed server-side business logic modules.", done: true},
            {name: "Actively participated in weekly code reviews.", done: true},
            {name: "Use VS Code as IDE tool to develop the application.", done: true},
            {name: "Created technical documents based on epics as we complete the stories.", done: true},
            {name: "Worked closely with project managers and other team members to form a team effort in development when have dependencies.", done: true},
            {name: "Closely worked with the QA team for testing and resolve bugs in the application.", done: true},
            {name: "Knowledge Transfer: Gave presentations to the other teams about the work we have done and explained various features we developed on the ongoing project.", done: true},
        ],
        tags: "Laravel, MySQL, Lumen, REST API, AJAX"
    },
    {
        key: "podprime",
        title: "PODPrime",
        desc: "Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue. Curabitur ullamcorper ultricies nisi. Nam eget dui. Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam semper libero, sit amet adipiscing sem neque sed ipsum. Nam quam nunc, blanditvel, luctus pulvinar, hendrerit id, lorem.",
        image: "6-3.jpg",
        author: "Razul Mondal",
        client: "NTT",
        date: "May 15th, 2019",
        icon: "ti-light-bulb",
        features: [
            {name: "Designed the UI using Element UI, Vue JS and SASS.", done: true},
            {name: "Developed several REST web services and used JSON as a data exchange format.", done: true},
            {name: "Actively participated in weekly code reviews.", done: true},
            {name: "Use VS Code as IDE tool to develop the application.", done: true},
            {name: "Created technical documents based on epics as we complete the stories.", done: true},
            {name: "Worked closely with project managers and other team members to form a team effort in development when have dependencies.", done: true},
            {name: "Closely worked with the QA team for testing and resolve bugs in the application.", done: true},
            {name: "Knowledge Transfer: Gave presentations to the other teams about the work we have done and explained various features we developed on the ongoing project.", done: true},
        ],
        tags: "VueJs, Element UI, SASS, MongoDB, JSON, REST API, AJAX, CANVAS, STRIP"
    }
];

function ProjectDetails () {
    const history = useHistory();
    const { projectKey } = useParams()

    let project = projects.filter(item => item.key == projectKey)
    
    if (project.length == 0) {
        history.push("/404");
    }

    project = project[0]
    console.log(project)

    return (
        <section className="section section-single-post section-single-post-1">
            <div className="display-spacing">
                <Container>
                    <div className="max-w-768 div-center">
                        <div className="post">
                            <div className="post-head">
                                <div className="post-info">
                                    <GoBack />
                                    <h1>{project.title}</h1>
                                    <p>
                                        by <span className="author">{ project.author }</span> in <span className="category">{ project.client }</span> on <span className="date">{ project.date }</span>.
                                    </p>
                                </div>
                            </div>
                            <div className="post-body">
                                <div className="post-image">
                                    <img src={`/assets/images/project/${project.image}`} alt="Single Post" />
                                </div>
                                <div className="post-content">
                                    {/* <p>{ project.desc }</p> */}
                                    <p>
                                        <b>Key Features:</b>
                                    </p>
                                    <ul className="el-list-check">
                                        {project.features.map((item, index) => (
                                            <li key={index}>
                                                {item.done ? <FaCheck className="icon" /> : <FaTimes className="icon" style={{color: "red"}} />}
                                                
                                                {item.name}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="post-tags">
                                    <span>Tags:</span>
                                    <ul>
                                        {project.tags.split(', ').map((item, index) => (
                                            <li key={index}>
                                                <a>{ item }</a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </section>
    );
}

export default ProjectDetails;